import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {StationInfo} from "../model/StationInfo";
import {LegacyPageEvent as PageEvent} from "@angular/material/legacy-paginator";
import {MatLegacyDialog as MatDialog} from "@angular/material/legacy-dialog";
import {AdditionalStationInfoService} from "./additional-station-info-service"
import {AddStationInfoDialogComponent} from "../add-station-info-dialog/add-station-info-dialog.component";
import {ImageService, ImageUrl} from '../images/image.service';
import {findImageUrlForLabel} from '../images/image-label.utils';
import {finalize, Observable, of} from 'rxjs';
import {ConfirmationDialogComponent} from "../confirmation-dialog/confirmation-dialog.component";
import {MatLegacySlideToggleChange as MatSlideToggleChange} from "@angular/material/legacy-slide-toggle";
import {UserRoleProviderService} from "../auth/user-role-provider-service";
import {Role} from "../model/Role";


@Component({
  selector: 'met-additional-station-info',
  templateUrl: './additional-station-info.component.html',
  styleUrls: ['./additional-station-info.component.scss']
})
export class AdditionalStationInfoComponent implements OnInit {

  stationInfos: StationInfo[] = [];
  columnsToDisplay: string[] = ['infoLabel', 'isactive', 'icon'];

  pageNo = 0;
  currentPageSize = 5;
  length = 0;
  pageSizes: number[] = [5, 10, 20];
  isSaving: Record<number | string, boolean> = {};

  imageUrls$: Observable<ImageUrl[]> = of([]);

  defaultIcon = 'assets/default-icon.png';
  canViewStationInfo = false;
  canEditStationInfo = false;
  canDeleteStationInfo = false;

  constructor(
    private dialog: MatDialog,
    private additionalStationInfoService: AdditionalStationInfoService,
    private imageService: ImageService,
    private userRoleProviderService: UserRoleProviderService
  ) {}

  ngOnInit(): void {
    this.canViewStationInfo = this.userRoleProviderService.hasRequiredRole(Role.station_info_view);
    this.canEditStationInfo = this.userRoleProviderService.hasRequiredRole(Role.station_info_edit);
    this.canDeleteStationInfo = this.userRoleProviderService.hasRequiredRole(Role.station_info_delete);
    this.updateColumns();

    if (!this.canViewStationInfo) {
      return;
    }

    this.additionalStationInfoService.count('').subscribe(total => {
      this.length = total;
      this.loadData();
    });
    this.imageUrls$ = this.imageService.getStationImageUrls('stationInfo');
  }

 loadData(): void {
   if (!this.canViewStationInfo) {
     return;
   }
   this.additionalStationInfoService.getAll(this.pageNo, this.currentPageSize, '')
     .subscribe(data => this.stationInfos = data);

    this.additionalStationInfoService.count('').subscribe(total => {
      this.length = total;
    });

   this.imageUrls$ = this.imageService.getStationImageUrls("stationInfo");
  }

  addInfo(): void {
    if (!this.canEditStationInfo) {
      return;
    }
    const dialogRef = this.dialog.open(AddStationInfoDialogComponent, {
      width: '400px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.loadData();
        window.location.reload();
      }
    });
  }

  @Output()
  pagingChanged = new EventEmitter<{ pageIndex: number; pageSize: number }>();


  get paginatedData(): StationInfo[] {
    const start = this.pageNo * this.currentPageSize;
    return this.stationInfos.slice(start, start + this.currentPageSize);
  }


  editInfo(info: StationInfo): void {
    if (!this.canEditStationInfo) {
      return;
    }
    const dialogRef = this.dialog.open(AddStationInfoDialogComponent, {
      width: '400px',
      data: { ...info }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.loadData();
        window.location.reload();
      }
    });
  }

  deleteInfo(id: number): void {
    if (!this.canDeleteStationInfo) {
      return;
    }
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: 'Möchten Sie diese Stationsinfo wirklich löschen?'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.additionalStationInfoService.delete(id).subscribe({
          next: () => this.loadData(),
          error: (err) => console.error('Löschen fehlgeschlagen:', err)
        });
      }
    });
  }

  getImageUrlForLabel(infoLabel: string, images: ImageUrl[]): string {
    return findImageUrlForLabel(infoLabel, images, this.defaultIcon);
  }


  onImageError(event: Event) {
    (event.target as HTMLImageElement).src = this.defaultIcon;
  }

  onToggleActive(element: StationInfo, ev: MatSlideToggleChange) {
    if (!this.canEditStationInfo) {
      ev.source.checked = element.active;
      return;
    }
    const previous = element.active;
    const next = ev.checked;

    element.active = next;
    this.isSaving[element.id] = true;

    this.additionalStationInfoService.edit(
      {...element, active: next}, /* file */ undefined
    ).pipe(
      finalize(() => this.isSaving[element.id] = false)
    ).subscribe({
      error: () => {
        element.active = previous;

      }
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageNo = event.pageIndex;
    if (this.currentPageSize !== event.pageSize) {
      this.currentPageSize = event.pageSize;
      this.pageNo = 0;
    }
    this.loadData();
  }

  private updateColumns(): void {
    this.columnsToDisplay = ['infoLabel', 'isactive', 'icon'];
    if (this.canEditStationInfo || this.canDeleteStationInfo) {
      this.columnsToDisplay.push('actions');
    }
  }
}
